import { render } from "./ResetPasswordPage.vue?vue&type=template&id=01c539c2&scoped=true&ts=true"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=ts&setup=true"

import "./ResetPasswordPage.vue?vue&type=style&index=0&id=01c539c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c539c2"],['__file',"src/pages/login/ResetPasswordPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01c539c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01c539c2', __exports__)) {
    api.reload('01c539c2', __exports__)
  }
  
  module.hot.accept("./ResetPasswordPage.vue?vue&type=template&id=01c539c2&scoped=true&ts=true", () => {
    api.rerender('01c539c2', render)
  })

}


export default __exports__